module.exports = __webpack_public_path__ + "static/media/mood_3.e9760668.svg";